import React from 'react';

const TermsPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white shadow-lg rounded-lg overflow-hidden">
          <div className="bg-primary-600 px-6 py-4">
            <h1 className="text-3xl font-bold text-white">Terms of Service</h1>
            <p className="text-primary-100 mt-2">Last Updated: December 15, 2023</p>
          </div>
          
          <div className="px-6 py-8 prose prose-lg max-w-none">
            <h2>1. Agreement to Terms</h2>
            <p>Welcome to Crawly Carl ("we," "our," or "us"). By accessing or using our web scraping API service, Chrome extension, or any other services we provide (collectively, the "Services"), you agree to be bound by these Terms of Service ("Terms"). If you do not agree to these Terms, please do not use our Services.</p>
            <p>These Terms govern your access to and use of the Services. Please read these Terms carefully before using the Services. By using the Services, you agree to these Terms. If you are using the Services on behalf of an organization (such as your employer), you are agreeing to these Terms for that organization and promising that you have the authority to bind that organization to these Terms. In that case, "you" and "your" will refer to that organization.</p>

            <h2>2. Description of Services</h2>
            <p>Crawly Carl provides an AI-powered web scraping API that enables users to extract data from websites using natural language requests. Our Services include:</p>
            <ul>
              <li>Web scraping API services</li>
              <li>Chrome browser extension</li>
              <li>Related documentation and support services</li>
            </ul>
            <p>We reserve the right to modify, suspend, or discontinue the Services (or any part thereof) at any time, with or without notice. We will not be liable to you or to any third party for any modification, suspension, or discontinuation of the Services.</p>

            <h2>3. User Accounts</h2>
            <p>To access certain features of the Services, you may be required to register for an account. You must provide accurate, current, and complete information during the registration process and keep your account information up-to-date.</p>
            <p>You are responsible for safeguarding your account credentials and for all activities that occur under your account. You agree to notify us immediately of any unauthorized use of your account or any other breach of security. We cannot and will not be liable for any loss or damage arising from your failure to comply with this section.</p>
            <p>We reserve the right to disable any user account if, in our opinion, you have violated any provision of these Terms.</p>

            <h2>4. Payment Terms</h2>
            <p>Some of our Services require payment. If you choose a paid subscription:</p>
            <ul>
              <li>You agree to pay all fees associated with your subscription plan.</li>
              <li>Subscription fees will be charged at the beginning of your subscription and each renewal period.</li>
              <li>All fees are non-refundable except as expressly provided in these Terms or when required by law.</li>
              <li>We may change subscription fees at any time, but we will provide notice of any fee change and the opportunity to cancel before the new fees apply to you.</li>
              <li>If your payment cannot be processed, we may suspend or terminate your account.</li>
            </ul>
            <p>If you exceed your subscription plan's usage limits, you will be charged according to our overage rates as described on our pricing page.</p>

            <h2>5. API Usage Policy</h2>
            <p>Your use of our API is subject to the following policies:</p>
            <ul>
              <li>You may not use our API for any purpose that violates applicable laws or regulations.</li>
              <li>You may not attempt to reverse engineer, decompile, or disassemble our API.</li>
              <li>You may not share your API keys or credentials with third parties.</li>
              <li>You must comply with all usage limits and rate restrictions for your subscription plan.</li>
              <li>You are responsible for all activities conducted with your API keys.</li>
            </ul>
            <p>We reserve the right to monitor API usage and suspend access if we detect abnormal patterns or potential abuse.</p>

            <h2>6. Prohibited Uses</h2>
            <p>You agree not to use the Services to:</p>
            <ul>
              <li>Violate any law, regulation, or third-party rights</li>
              <li>Extract personal data in violation of privacy laws</li>
              <li>Scrape websites that explicitly prohibit scraping</li>
              <li>Impersonate or attempt to impersonate Crawly Carl, a Crawly Carl employee, another user, or any other person or entity</li>
              <li>Engage in any activity that interferes with or disrupts the Services (or the servers and networks connected to the Services)</li>
              <li>Attempt to access any portions of the Services that you are not authorized to access</li>
              <li>Use the Services for competitive analysis or to develop a competing product</li>
            </ul>

            <h2>7. Disclaimer of Warranties</h2>
            <p>THE SERVICES ARE PROVIDED "AS IS" AND "AS AVAILABLE" WITHOUT WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED, INCLUDING, BUT NOT LIMITED TO, IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, TITLE, AND NON-INFRINGEMENT. WE DO NOT WARRANT THAT THE SERVICES WILL BE UNINTERRUPTED OR ERROR-FREE, THAT DEFECTS WILL BE CORRECTED, OR THAT THE SERVICES OR THE SERVERS THAT MAKE THE SERVICES AVAILABLE ARE FREE OF VIRUSES OR OTHER HARMFUL COMPONENTS.</p>

            <h2>8. Limitation of Liability</h2>
            <p>IN NO EVENT WILL CRAWLY CARL, ITS AFFILIATES, OR THEIR LICENSORS, SERVICE PROVIDERS, EMPLOYEES, AGENTS, OFFICERS, OR DIRECTORS BE LIABLE FOR DAMAGES OF ANY KIND, UNDER ANY LEGAL THEORY, ARISING OUT OF OR IN CONNECTION WITH YOUR USE, OR INABILITY TO USE, THE SERVICES, INCLUDING ANY DIRECT, INDIRECT, SPECIAL, INCIDENTAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES.</p>

            <h2>9. Termination</h2>
            <p>These Terms shall remain in full force and effect while you use the Services. We may terminate your access to the Services, without cause or notice, which may result in the forfeiture and destruction of all information associated with your account.</p>

            <h2>10. Governing Law</h2>
            <p>These Terms shall be governed by and construed in accordance with the laws of the State of California, without regard to its conflict of law provisions. You agree to submit to the personal and exclusive jurisdiction of the courts located within San Francisco County, California.</p>

            <h2>11. Contact Us</h2>
            <p>If you have any questions about these Terms, please contact us at:</p>
            
            <div className="bg-gray-100 p-4 rounded-lg mt-4">
              <p><strong>Email:</strong> legal@crawlycarl.com</p>
              <p><strong>Address:</strong> Crawly Carl<br />
              1234 Market Street<br />
              San Francisco, CA 94103</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsPage;